export default __webpack_public_path__ + "static/blake-spread-d4bf0c8f189ec4466bda02e5db9478bd.jpg";